/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_FootnoteInputs */

const en_reading_class_footnote = /** @type {(inputs: Reading_Class_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footnotes`)
};

const es_reading_class_footnote = /** @type {(inputs: Reading_Class_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas al pie`)
};

/**
* | output |
* | --- |
* | "Footnotes" |
*
* @param {Reading_Class_FootnoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_footnote = /** @type {((inputs?: Reading_Class_FootnoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_FootnoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_footnote(inputs)
	return en_reading_class_footnote(inputs)
});